import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row dashboard__hero" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = {
  key: 1,
  class: "px-sm-2 px-xl-4 py-2_5"
}
const _hoisted_4 = { class: "row mb-2" }
const _hoisted_5 = { class: "col d-flex flex-column flex-md-row justify-content-between align-items-md-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "text-type-2-bold mb-1 mb-md-0" }, "Unemployment Rate", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("View Details ")
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 col-md-9" }
const _hoisted_10 = { class: "col-12 col-md-3 mt-2 mt-md-0" }
const _hoisted_11 = { class: "row row-cols-2 row-cols-md-1" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "text-type-5-bold text-label" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Unemployment Rate")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "text-type-1" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "dashboard__hero__stat" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Monthly Change:")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "dashboard__hero__stat" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Yearly Change:")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "row row-cols-1 row-cols-md-2 dashboard__grid mt-2_5 px-sm-2 px-xl-4" }
const _hoisted_29 = { class: "col" }
const _hoisted_30 = {
  key: 1,
  class: "dashboard__card p-1_5"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "section-title" }, "Payroll Jobs")
  ])
], -1)
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col d-flex align-items-center" }
const _hoisted_36 = { class: "text-type-2-bold" }
const _hoisted_37 = { class: "col" }
const _hoisted_38 = { class: "dashboard__card__stat" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Monthly Change:")
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "dashboard__card__stat" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Yearly Change:")
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("View Details ")
const _hoisted_51 = { class: "col" }
const _hoisted_52 = {
  key: 1,
  class: "dashboard__card p-1_5"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "section-title" }, "Labor Force Participation")
  ])
], -1)
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col d-flex align-items-center" }
const _hoisted_58 = { class: "text-type-1-bold" }
const _hoisted_59 = { class: "col" }
const _hoisted_60 = { class: "dashboard__card__stat" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Monthly Change:")
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { class: "dashboard__card__stat" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Yearly Change:")
const _hoisted_67 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = { class: "col" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode("View Details ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_som_icon_chevron_right = _resolveComponent("som-icon-chevron-right")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_som_icon_caret_up = _resolveComponent("som-icon-caret-up")!
  const _component_som_icon_caret_down = _resolveComponent("som-icon-caret-down")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.unemployRate == '')
          ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_router_link, {
                    to: `/unemployment/Unemployment`,
                    class: "btn btn-link dashboard__hero__cta"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createVNode(_component_som_icon_chevron_right, { size: "md" })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_LineChart, {
                    metricData: _ctx.unemployData,
                    dataLabels: _ctx.unemployDataLabels,
                    dataProps: _ctx.unemployDataProps,
                    options: _ctx.unemployOptions,
                    dateLabel: _ctx.unemployMetric.dateProp,
                    class: "dashboard__hero__chart"
                  }, null, 8, ["metricData", "dataLabels", "dataProps", "options", "dateLabel"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, [
                        _hoisted_14,
                        _hoisted_15,
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.unemployRate) + "%", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("p", _hoisted_18, [
                        _hoisted_19,
                        _hoisted_20,
                        (Number(_ctx.unemployMonthChange) > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                              _createVNode(_component_som_icon_caret_up, { color: "danger" })
                            ]))
                          : _createCommentVNode("", true),
                        (Number(_ctx.unemployMonthChange) < 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                              _createVNode(_component_som_icon_caret_down, { color: "success" })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(_ctx.unemployMonthChange), 1)
                      ]),
                      _createElementVNode("p", _hoisted_23, [
                        _hoisted_24,
                        _hoisted_25,
                        (Number(_ctx.unemployYearChange) > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                              _createVNode(_component_som_icon_caret_up, { color: "danger" })
                            ]))
                          : _createCommentVNode("", true),
                        (Number(_ctx.unemployYearChange) < 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                              _createVNode(_component_som_icon_caret_down, { color: "success" })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(_ctx.unemployYearChange), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        (_ctx.unemployRate == '')
          ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_LineChart, {
                    metricData: _ctx.payrollJobsData,
                    dataLabels: _ctx.payrollJobsDataLabels,
                    dataProps: _ctx.payrollJobsDataProps,
                    options: _ctx.payrollJobsOptions,
                    dateLabel: _ctx.payrollJobsMetric.dateProp,
                    isDashboardSubChart: true,
                    lineColorOverride: 2,
                    class: "dashboard__card__chart"
                  }, null, 8, ["metricData", "dataLabels", "dataProps", "options", "dateLabel"])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.payrollJobsRate), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("p", _hoisted_38, [
                    _hoisted_39,
                    _hoisted_40,
                    (_ctx.payrollJobsMonthChangeNum > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                          _createVNode(_component_som_icon_caret_up, { color: "success" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.payrollJobsMonthChangeNum < 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                          _createVNode(_component_som_icon_caret_down, { color: "danger" })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.payrollJobsMonthChange), 1)
                  ]),
                  _createElementVNode("p", _hoisted_43, [
                    _hoisted_44,
                    _hoisted_45,
                    (_ctx.payrollJobsYearChangeNum > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                          _createVNode(_component_som_icon_caret_up, { color: "success" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.payrollJobsYearChangeNum < 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                          _createVNode(_component_som_icon_caret_down, { color: "danger" })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.payrollJobsYearChange), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_router_link, {
                    to: `/laborForce/PayrollJobs`,
                    class: "btn btn-link dashboard__card__cta stretched-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_50,
                      _createVNode(_component_som_icon_chevron_right)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_51, [
        (_ctx.laborForceRate == '')
          ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createVNode(_component_LineChart, {
                    metricData: _ctx.laborForceData,
                    dataLabels: _ctx.laborForceDataLabels,
                    dataProps: _ctx.laborForceDataProps,
                    options: _ctx.laborForceOptions,
                    dateLabel: _ctx.laborForceMetric.dateProp,
                    isDashboardSubChart: true,
                    lineColorOverride: 3,
                    class: "dashboard__card__chart"
                  }, null, 8, ["metricData", "dataLabels", "dataProps", "options", "dateLabel"])
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.laborForceRate) + "%", 1)
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("p", _hoisted_60, [
                    _hoisted_61,
                    _hoisted_62,
                    (Number(_ctx.laborForceMonthChange) > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_63, [
                          _createVNode(_component_som_icon_caret_up, { color: "success" })
                        ]))
                      : _createCommentVNode("", true),
                    (Number(_ctx.laborForceMonthChange) < 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                          _createVNode(_component_som_icon_caret_down, { color: "danger" })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.laborForceMonthChange), 1)
                  ]),
                  _createElementVNode("p", _hoisted_65, [
                    _hoisted_66,
                    _hoisted_67,
                    (Number(_ctx.laborForceYearChange) > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_68, [
                          _createVNode(_component_som_icon_caret_up, { color: "success" })
                        ]))
                      : _createCommentVNode("", true),
                    (Number(_ctx.laborForceYearChange) < 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                          _createVNode(_component_som_icon_caret_down, { color: "danger" })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.laborForceYearChange), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(_component_router_link, {
                    to: `/laborForce/LaborForceParticipation`,
                    class: "btn btn-link dashboard__card__cta"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_72,
                      _createVNode(_component_som_icon_chevron_right)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
      ])
    ])
  ], 64))
}